import React from 'react';

import { Theme } from '@mui/material/styles';
import makeStyles from '@mui/styles/makeStyles';
import clsx from 'clsx';

import { Skeleton } from '../../../../../components/atoms/Skeleton';

const useStyles = makeStyles((theme: Theme) => ({
  buttonSkeleton: {
    height: '36px',
    marginTop: theme.spacing(1),
    width: '36px',
  },
  contentContainer: {
    display: 'flex',
    flex: 1,
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
  imageSkeleton: {
    height: '72px',
    marginRight: theme.spacing(1),
    width: '72px',
  },
  list: {
    margin: 0,
    padding: theme.spacing(2, 0, 0),
  },
  listItem: {
    borderTop: `1px solid ${theme.palette.grey[400]}`,
    display: 'flex',
    justifyContent: 'space-between',
    padding: theme.spacing(1.5, 0),
  },
  textContainer: {
    width: '30%',
  },
}));

export function CrossSellListSkeleton(): JSX.Element {
  const classes = useStyles();
  const rootStyles = clsx('fd-cross-sell-list-skeleton');

  const renderCrossSellItemsSkeleton = () =>
    Array(3)
      .fill(true)
      .map((_, i) => (
        // eslint-disable-next-line react/no-array-index-key
        <li className={classes.listItem} key={`cross-sell-skeleton-${i}`}>
          <Skeleton className={classes.imageSkeleton} variant="rect" />
          <div className={classes.contentContainer}>
            <div className={classes.textContainer}>
              <Skeleton />
              <Skeleton />
            </div>
            <div>
              <Skeleton />
              <Skeleton className={classes.buttonSkeleton} variant="circle" />
            </div>
          </div>
        </li>
      ));
  return (
    <div className={rootStyles} data-fd="cross-sell-skeleton">
      <Skeleton className={classes.textContainer} />
      <div>
        <ul className={classes.list}>{renderCrossSellItemsSkeleton()}</ul>
      </div>
    </div>
  );
}
